
// 例子
const option = {
  // 距离边框距离
  grid: {
    // 关键：把 bottom 调小，直接减少底部空白
    top:  10,    // 顶部留白（可根据需要调整）
    left: 10,   // 左侧留白
    right: 10,  // 右侧留白
    bottom: 10,  // 底部留白！设为0就能紧贴容器底部
    containLabel: true // 自动包含坐标轴标签，避免文字被裁
  },
  // 颜色-内容
  legend: {
    right: '0%',
    top: '0%',
    // orient: 'vertical', // 开启竖排
    selectedMode: false,
    // itemStyle: {
    //   width: 5,  // 边框颜色
    //   borderWidth: 2,          // 边框宽度
    //   opacity: 0.9,            // 透明度
    //   // 还支持 shadowColor、shadowBlur、shadowOffsetX/Y 等
    // },
  },
  tooltip:{
    // trigger: 'axis',
    show: true,
    formatter: "{b}: {c}"
  },
  series: [
    // 环
    {
      // name: 'Access From',
      type: 'pie',
      radius: ['35%', '50%'], // 半圆环外半径和内半径
      center: ['50%', '50%'],
      avoidLabelOverlap: false,
      label: {
        show: true,
        fontSize: 13,
        // formatter: "{b}: {c}",
        formatter: "{c}",
      },
      distance: 2,
      data: [
        { value: 1048, name: '可用数量' , itemStyle:{color: 'rgba(0,209,200,1)'}},
        { value: 735, name: '已使用数量 ', itemStyle:{color: 'rgba(255,168,27,1)'} },
      ],
    },{// 环中间的Total
      type: 'pie',
      avoidLabelOverlap: false,
      radius: ['0%', '0%'], 
      center: ['50%', '52%'],
      data: [
        { value: 1048, name: '', itemStyle:{color: 'rgba(0,209,200,1)'} }
      ],
      silent: true,          // 关闭所有鼠标悬停响应（动画+高亮+tooltip）
      hoverAnimation: false,  // 关闭hover动画
      emphasis: { disabled: true }, // 关闭高亮状态
      labelLine: {
        show: false
      },
      label: {
        show: true,
        position: 'center',  // 永远在正中心
        fontSize: 18,
        fontWeight: 'bold',
        formatter: 'Title', // 显示总和
        color: '#333'
      },
    }
  ]
};
/*
  title: string
  data : [
    {value: number, name: string, color: string }
  ]
*/
export function getPie(title, data, big){
  if(!big){
    big = true;
  }
  let pieOpt = {
    ...option,
    series: [
      {
        ...option.series[0],
        center: big ?['50%', '55%'] :['50%', '55%'],
        data: data.map(i => {
          return {
            value: i.value,
            name : i.name,
            itemStyle: {
              color: i.color,
            },
          }
        }),
      },
      title
        ? {
          ...option.series[1],
          center: big ?['50%', '57%'] :['50%', '57%'],
          label: {
            ...option.series[1].label,
            formatter : title,
          }
        }
        : undefined,
    ],
  }
  pieOpt.legend = {
    ...pieOpt.legend,
    selected : {},
  }
  if(data.every(i => i.value == 0)){
    data.forEach(i => pieOpt.legend.selected[i.name] = false)
  } else {
    data.forEach(i => pieOpt.legend.selected[i.name] = true)
  }
  return pieOpt
}